<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>
export default {
  name: "my-tour",

  computed: {
    layout() {
      return `${this.$route.meta.layout || "default"}-layout`;
    }
  },
  mounted() {
    this.$tours["myTour"].start();
    
  },
  data() {
    return {};
  }
};
</script>
<style lang="scss">
table td {
  font-size: 16px !important;
  line-height: 1.4 !important;
  text-align: left !important;
}
.card-style {
  border-radius: 10px;
  box-shadow: 0 2px 0 rgba(90, 97, 105, 0.11), 0 4px 8px rgba(90, 97, 105, 0.12),
    0 10px 10px rgba(90, 97, 105, 0.06), 0 7px 70px rgba(90, 97, 105, 0.1);
  padding: 25px;
}
.card-header:first-child {
  padding-left: 0px;
}

.btn-primary {
  border-color: #f6f6f6;
  background: linear-gradient(#f4f5f8, #f1f3f6) !important;
  background-color: #ffffff00;
  color: #232349;
  box-shadow: 0 1px 2px rgba(#232349, 0.3), inset 0 1px 0 #fff !important;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 800;
  box-shadow: none;
  border-radius: 5px;
  border-color: none;
  :hover {
    border-color: #232349 !important;
    background-color: #232349 !important;
    color: #232349 !important;
    box-shadow: none !important;
  }
  :active {
    border-color: #f2557a;
    background-color: #f2557a;
  }
}

.btn-primary2 {
  border-color: #f6f6f6;
  background: linear-gradient(#f4f5f8, #f1f3f6) !important;
  background-color: #ffffff00;
  color: #232349;
  box-shadow: 0 1px 2px rgba(#232349, 0.3), inset 0 1px 0 #fff !important;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 800;
  box-shadow: none;
  border-radius: 5px;
  border-color: none;
  :hover {
    // border-color: #232349 !important;
    // background-color: #232349 !important;
    // color: #232349 !important;
    box-shadow: none !important;
  }
  :active {
    border-color: #f2557a;
    background-color: #f2557a;
  }
}

.vgt-wrap__footer .footer__navigation__page-btn .chevron.left::after {
  border-right: 6px solid #f2557a !important;
  margin-left: -3px;
}

.vgt-table thead th.sorting-desc:before {
  border-top: 5px solid #f2557a !important;
}
.vgt-table thead th.sorting-asc:after {
  border-bottom: 5px solid #f2557a !important;
}

.main-sidebar .nav .nav-item .nav-link:hover {
  box-shadow: inset 0.1875rem 0 0 #f2557a;
}

.btn-primary:hover {
  box-shadow: 0 5px 15px rgba(#232349, 0.05), 0 4px 10px rgba(#232349, 0.25);
  color: #232349 !important;
}

.btn-primary:not(:disabled):not(.disabled):active {
  border-color: #f2557a;
  background-color: #f2557a;
}
a {
  color: #232349;
}
body {
  background: #fff;
}
.btn-blue {
  border: 0px solid;
  border-radius: 5px;
}

.btn-white {
  color: #9191a0 !important;
  border-color: #f2557a;
  :active {
    color: #006fe662;
    border-color: #f2557a;
    background-color: #f2557a;
  }
}
.alert-primary {
  color: #f5faff;
  background-color: #f2557a;
}
.v-tour__target--highlighted {
  box-shadow: 0 0 0 9000px rgba(0, 0, 0, 0.6) !important;
}
</style>
